import { useEffect, useRef } from "react";
import { useDocumentListener } from "./listeners";
import { useOnMounted } from "./mounted";

type DialogTriggerProps = {
  isOpen: boolean;
  open: () => void;
  triggerId: string | undefined;
};

export function useDialogTriggers({ isOpen, open, triggerId }: DialogTriggerProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const $triggerId = triggerId ?? "dewey--search--trigger";

  // On first load, open the Dialog if the search trigger is focused
  useOnMounted(() => {
    const trigger = document.getElementById($triggerId);
    if (document.activeElement === trigger) {
      open();
    }
  });

  // Listen for clicks on the search trigger
  useDocumentListener("click", (event: Event) => {
    const { target } = event;
    if (target instanceof Element) {
      const triggerElement = target.closest(`#${$triggerId}`);
      if (triggerElement) {
        open();
      }
    }
  });

  // Handle opening/closing the dialog when the isOpen prop changes
  const bodyOverflow = useRef("");
  useEffect(() => {
    if (isOpen) {
      bodyOverflow.current = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
      document.body.style.overflow = bodyOverflow.current;
    }
  }, [isOpen]);

  return dialogRef;
}
